import { render, staticRenderFns } from "./MenuChangeEdit.vue?vue&type=template&id=0a838360&scoped=true"
import script from "./MenuChangeEdit.vue?vue&type=script&lang=js"
export * from "./MenuChangeEdit.vue?vue&type=script&lang=js"
import style0 from "./MenuChangeEdit.vue?vue&type=style&index=0&id=0a838360&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a838360",
  null
  
)

export default component.exports